const initialState = {
  loadedAddresses: {
    data: [],
    next: '',
    count: 0,
    found: false,
  },
  loadedPointsOfInterest: {
    venues: [],
    addresses: [],
  },
  cityData: {},
};

const initialStateForTest = {
  loadedAddresses: {
    data: [],
    next: '',
    count: 0,
    found: false,
  },
  loadedPointsOfInterest: {
    venues: [],
    addresses: [],
  },
  cityData: {},
};

export default initialState;
export { initialStateForTest };
